import VacanciesEmptyState from './VacanciesEmptyState.component';

export default VacanciesEmptyState;
